import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OverviewComponent } from './overview/overview.component';
import { StatementsComponent } from './statements/statements.component';
import { DirectoryComponent } from './directory/directory.component';
import { PictureDirectoryComponent } from './picture-directory/picture-directory.component';
import { AnnouncementsComponent } from './announcements/announcements.component';
import { MemberInfoComponent } from './member-info/member-info.component';
import { FamiliesInfosDetailComponent } from './families-detail/families-detail.component';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { VotesOverviewComponent } from './votes-overview/votes-overview.component';
import { ConstructionComponent } from './construction/construction.component';
import { NominationComponent } from './nomination/nomination.component';
import { CalendarComponent } from './calendar/calendar.component';
import { EventCalendarComponent } from './event-calendar/event-calendar.component';
import { CommitteePortalComponent } from './committee-portal/committee-portal.component';
import { PrepareGuard } from 'app/core/prepare.guard';
import { DocumentPackageComponent } from './document-package/document-package.component';
@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'portal',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'login', pathMatch: 'full' },
                    { path: 'login', component: OverviewComponent, data: { title: 'Member Portal' }},
                    { path: 'directory', component: DirectoryComponent, data: { title: 'Directory' }, canActivate: [PrepareGuard] },
                    { path: 'pictures', component: PictureDirectoryComponent, data: { title: 'Picture Directory' }, canActivate: [PrepareGuard] },
                    { path: 'statement', component: StatementsComponent, data: { title: 'Giving - Statements', hideNav: true }, canActivate: [PrepareGuard] },
                    { path: 'announcements', component: AnnouncementsComponent, data: { title: 'Announcements' }, canActivate: [PrepareGuard] },
                    { path: 'construction', component: ConstructionComponent, data: { title: 'Construction' }, canActivate: [PrepareGuard] },
                    { path: 'calendar', component: CalendarComponent, data: { title: 'Birthdays and Anniversaries' }, canActivate: [PrepareGuard] },
                    { path: 'event-calendar', component: EventCalendarComponent, data: { title: 'Weekly Calendar' }},
                    { path: 'member-info', component: MemberInfoComponent, data: { title: 'Member Information' }, canActivate: [PrepareGuard] },
                    { path: 'committees', component: CommitteePortalComponent, data: { title: 'Committees' }, canActivate: [PrepareGuard] },
                    { path: 'votes/:id', component: VotesOverviewComponent, data: { title: 'Proposal Vote', hideNav: true } },
                    { path: 'nominations/:id', component: NominationComponent, data: { title: 'Nomination', hideNav: true } },
                    { path: 'document-package/:userId', component: DocumentPackageComponent, data: { title: 'Document Package', hideNav: true } },

                ],
            },
        ]),
    ],
})
export class MemberPortalModule {}
